import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import SaidaTable from '../components/saida/SaidaTable';

const Saidas: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Saídas
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Gerencie as notas de saída consignada
        </Typography>
      </Box>

      <SaidaTable />
    </Container>
  );
};

export default Saidas;
